module.exports = __webpack_public_path__ + "21f3da706844504219ee09dac35f53d2.png";